import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import './styles/app.scss';
import { store } from './store';
ReactDOM.render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(App, {}) })), document.getElementById('root'));
